// @ts-nocheck
import html2pdf from 'html2pdf.js'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabase/client'
import './ResultsPage.css'
import TalentIcon from './TalentIcon'
import TalentLevels from './TalentLevels'

// Вынесем секцию таланта в отдельный компонент для лучшей организации
const TalentSection = ({
  talent,
  talentData,
  expandedTalents,
  toggleTalentIPR,
  formatSkills,
  getLevels,
}) => {
  const levels = getLevels(talent.Levels)
  const currentLevelDescription =
    talentData.level > 0 && talentData.level <= levels.length
      ? levels[talentData.level - 1]
      : 'Уровень не определен'

  const softSkills = formatSkills(talent.Soft)
  const hardSkills = formatSkills(talent.Hard)

  return (
    <div className="talent-section">
      {/* Группа элементов, которые должны быть на одной странице */}
      <div className="talent-info-group">
        <h3 className="talent-title">{talent.Tittle}</h3>
        <div className="business-roles">
          {/* Отображаем иконку */}
          <TalentIcon talentId={talent.Number} name={talent.Tittle} />
          {talent.Role}
        </div>
      </div>

      {/* Основное описание таланта */}
      <div className="talent-info-group">
        <div className="talent-description">
          <strong>Потенциал:</strong>
          <p>{talent.Potential}</p>
        </div>
      </div>

      {/* Ответ на вопрос */}
      <div className="talent-info-group">
        <div className="talent-description">
          <strong>Опыт применения таланта:</strong>
          <p className="response-text">
            <em>Вопрос: {talent.Questions}</em>
            <br />
            <strong>Ответ:</strong> {talentData.response || 'Нет ответа'}
          </p>
        </div>
      </div>

      {/* Текущий уровень */}
      <div className="talent-info-group">
        <div className="talent-description">
          <strong>Текущий уровень развития:</strong>
          <p>{currentLevelDescription}</p>
        </div>
      </div>

      {/* Числовые индикаторы */}
      <div className="talent-info-group">
        <TalentLevels level={talentData.level} satisfaction={talentData.satisfaction} />
      </div>

      {/* Кнопка ИПР - не отображается в PDF */}
      <div className="ipr-button-container no-print">
        <button className="ipr-button" onClick={() => toggleTalentIPR(talent.Number)}>
          {expandedTalents[talent.Number] ? 'Скрыть ИПР' : 'Создать ИПР'}
        </button>
      </div>

      {/* План развития */}
      {expandedTalents[talent.Number] && (
        <div className="ipr-section">
          <h4>Индивидуальный план развития</h4>

          {softSkills.length > 0 && (
            <div className="skills-section">
              <h5>Софт-скиллы для развития:</h5>
              <div className="skills-list">
                {softSkills.map((skill, index) => (
                  <div key={`soft-${index}`} className="skill-item">
                    <div className="skill-name">{skill.name}</div>
                    {skill.description && (
                      <div className="skill-description">{skill.description}</div>
                    )}
                    {skill.example && (
                      <div className="skill-example">
                        <strong>Пример:</strong> {skill.example}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {hardSkills.length > 0 && (
            <div className="skills-section">
              <h5>Хард-скиллы для развития:</h5>
              <div className="skills-list">
                {hardSkills.map((skill, index) => (
                  <div key={`hard-${index}`} className="skill-item">
                    <div className="skill-name">{skill.name}</div>
                    {skill.description && (
                      <div className="skill-description">{skill.description}</div>
                    )}
                    {skill.example && (
                      <div className="skill-example">
                        <strong>Пример:</strong> {skill.example}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="ipr-actions">
            <h5>Рекомендации для развития до следующего уровня:</h5>
            <p>Для развития таланта рекомендуется:</p>
            <ul>
              <li>Определить 1-2 ключевых навыка для фокусного развития</li>
              <li>Найти обучающие программы или курсы по выбранным навыкам</li>
              <li>Применять навыки на практике в рабочих проектах</li>
              <li>Получать регулярную обратную связь от коллег</li>
              <li>Отслеживать прогресс развития и корректировать план</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
const ResultsPage = ({ userData, userId }) => {
  const navigate = useNavigate()
  const [expandedTalents, setExpandedTalents] = useState({})
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false)
  const [isSavingProfile, setIsSavingProfile] = useState(false)

  // Новые состояния для интеграции с личным кабинетом
  const [saveSuccess, setSaveSuccess] = useState(false)
  const [saveError, setSaveError] = useState(null)

  // Сохраняем данные в localStorage при монтировании компонента
  useEffect(() => {
    if (userData) {
      localStorage.setItem('userDataResults', JSON.stringify(userData))
    }
  }, [userData])

  // Проверка наличия данных
  if (!userData) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Данные не найдены</h2>
        <p>Для получения результатов необходимо пройти тест.</p>
        <button onClick={() => navigate('/')} className="btn">
          Вернуться на главную
        </button>
      </div>
    )
  }

  // Безопасно извлекаем свойства из userData с дефолтными значениями
  const personalInfo = userData || {}
  const talentIndices = userData.talentIndices || []
  const talents = userData.talents || []
  const talentLevels = userData.talentLevels || []
  const satisfactionLevels = userData.satisfactionLevels || []
  const talentResponses = userData.talentResponses || []

  // Filter out any talent indices that don't exist in our database
  const validTalentIndices = talentIndices.filter((index) =>
    talents.some((talent) => Number(talent.Number) === Number(index)),
  )

  // Функция для сохранения профиля - объединяем старый код с новой функциональностью
  const saveProfile = async () => {
    try {
      setIsSavingProfile(true)
      setSaveError(null)

      // Получаем currentUserId из localStorage или используем переданный userId
      const currentUserId =
        localStorage.getItem('currentUserId') || userId || generateUserId(personalInfo)
      const {
        data: { user },
      } = await supabase.auth.getUser()
      const currentUserUuid = user?.id || null

      // Форматируем данные профиля
      const formattedTalents = formatTalentsForProfile()

      // Формирование статистики
      const statistics = [
        {
          value: `${talentLevels.length}`,
          label: 'Развитых талантов',
        },
        {
          value: `${Math.round((talentLevels.reduce((acc, item) => acc + item.level, 0) / talentLevels.length) * 100) / 100}`,
          label: 'Средний уровень',
        },
        {
          value: `${Math.round((satisfactionLevels.reduce((acc, item) => acc + item.level, 0) / satisfactionLevels.length) * 100) / 100}`,
          label: 'Средняя удовлетворенность',
        },
      ]

      // Отправка данных на Supabase
      try {
        const { data, error } = await supabase
          .from('ipr_profiles')
          .upsert({
            userId: currentUserId,
            uuid: currentUserUuid,
            profileData: {
              ...personalInfo,
              talents: formattedTalents,
              statistics,
            },
          })
          .select()

        if (error) {
          throw new Error(error.message || 'Ошибка при сохранении профиля')
        }

        console.log('Профиль успешно сохранен:', data)

        // Сохраняем данные также в localStorage для использования в ProfilePage
        localStorage.setItem(
          'userProfileData',
          JSON.stringify({
            userId: currentUserId,
            profileData: {
              ...personalInfo,
              talents: formattedTalents,
              statistics,
            },
          }),
        )
      } catch (error) {
        console.error('Ошибка при сохранении профиля:', error)
        setSaveError(error.message)
        return // Exit early on error to avoid navigation
      }

      // После успешного сохранения перенаправляем на страницу профиля
      navigate(`/profile/${currentUserId}`)
    } catch (error) {
      console.error('Ошибка при подготовке данных профиля:', error)
      setSaveError(error.message)
    } finally {
      setIsSavingProfile(false)
    }
  }

  // Функция для форматирования талантов в формат профиля
  const formatTalentsForProfile = () => {
    const formattedTalents = []

    validTalentIndices.forEach((talentId) => {
      const talent = getTalentById(talentId)
      if (!talent) return

      const talentData = getTalentData(talentId)

      // Добавляем ответ пользователя на вопрос, если он есть
      const responseData = talentData.response || ''

      formattedTalents.push({
        id: talentId,
        name: talent.Tittle,
        role: talent.Role,
        level: talentData.level || 0,
        satisfaction: talentData.satisfaction || 0,
        description: talent.Potential,
        skills: talent.Soft ? talent.Soft.split('\n')[0] : '',
        response: responseData, // Добавляем ответ пользователя на вопрос
      })
    })

    return formattedTalents
  }

  // Функция для генерации уникального ID на основе личной информации
  const generateUserId = (personalInfo) => {
    const { firstName, lastName } = personalInfo
    const timestamp = new Date().getTime()
    const randomPart = Math.floor(Math.random() * 10000)

    // Создаем уникальный ID на основе имени, фамилии и временной метки
    const namePart = `${firstName || ''}${lastName || ''}`.toLowerCase().replace(/[^a-z0-9]/g, '')

    return `${namePart}_${timestamp}_${randomPart}`
  }

  // Улучшенная функция генерации PDF с исправленным форматированием
  const generatePDF = async () => {
    try {
      setIsGeneratingPDF(true)

      // Создаем временный элемент для генерации PDF
      const printElement = document.createElement('div')
      printElement.innerHTML = document.getElementById('report-content').innerHTML
      printElement.classList.add('pdf-container')

      // Добавляем специальный класс для PDF-версии, чтобы применить особые стили
      printElement.classList.add('pdf-version')

      // Добавляем дату генерации для отображения в колонтитуле
      const today = new Date()
      const dateStr = today.toLocaleDateString('ru-RU')
      printElement.setAttribute('data-date', dateStr)

      // Устанавливаем стили для правильного разбиения на страницы
      document.body.appendChild(printElement)

      // Улучшаем структуру документа для предотвращения разрывов
      const talentSections = printElement.querySelectorAll('.talent-section')
      talentSections.forEach((section, index) => {
        // Добавляем атрибут для принудительного предотвращения разрыва внутри секции
        section.setAttribute(
          'data-talent-index',
          String(index + 1),
        )(section as HTMLElement).style.pageBreakInside = 'avoid'(
          section as HTMLElement,
        ).style.breakInside = 'avoid'

        // Начинаем каждую секцию таланта с новой страницы (кроме первой)
        if (index > 0) {
          ;(section as HTMLElement).style.pageBreakBefore =
            'always'(section as HTMLElement).style.breakBefore =
            'page'(section as HTMLElement).style.marginTop =
              '1cm'
        }

        // Группируем заголовок и основную информацию таланта
        const title = section.querySelector('.talent-title')
        const role = section.querySelector('.talent-role')
        const potentialDesc = section.querySelector('.talent-description')

        if (title && role && potentialDesc) {
          // Создаем обертку для критически важных элементов, которые нельзя разрывать
          const wrapper = document.createElement('div')
          wrapper.classList.add('talent-info-group')
          wrapper.style.pageBreakInside = 'avoid'
          wrapper.style.breakInside = 'avoid'

          // Перемещаем элементы в обертку
          title.parentNode.insertBefore(wrapper, title)
          wrapper.appendChild(title)
          wrapper.appendChild(role)
          wrapper.appendChild(potentialDesc)
        }

        // Улучшаем форматирование бизнес-ролей
        if (role) {
          const roleText = role.textContent

          // Извлекаем значения
          let roleValue = roleText
          if (roleText.includes(':')) {
            const parts = roleText.split(':')
            const roleLabel = parts[0].trim()
            roleValue = parts.slice(1).join(':').trim()

            // Форматируем с заголовком
            role.innerHTML = `<strong>${roleLabel}:</strong> ${roleValue}`
          }

          // Добавляем визуальное выделение
          ;(role as HTMLElement).style.color =
            '#10BDC8'(role as HTMLElement).style.fontWeight =
            'normal'(role as HTMLElement).style.fontSize =
            '14pt'(role as HTMLElement).style.marginBottom =
            '0.4cm'(role as HTMLElement).style.paddingBottom =
            '0.2cm'(role as HTMLElement).style.borderBottom =
              '1px solid #eee'
        }

        // Улучшаем уровни и навыки для лучшего отображения
        const levelsContainer = section.querySelector('.levels-container')
        if (levelsContainer) {
          ;(levelsContainer as HTMLElement).style.pageBreakInside =
            'avoid'(levelsContainer as HTMLElement).style.breakInside =
            'avoid'(levelsContainer as HTMLElement).style.marginBottom =
              '0.5cm'
        }

        const skillsContainer = section.querySelector('.skills-container')
        if (skillsContainer) {
          ;(skillsContainer as HTMLElement).style.pageBreakInside = 'avoid'(
            skillsContainer as HTMLElement,
          ).style.breakInside = 'avoid'

          // Обновляем заголовок навыков для лучшего отображения
          const skillsTitle = skillsContainer.querySelector('h3')
          if (skillsTitle) {
            ;(skillsTitle as HTMLElement).style.pageBreakAfter =
              'avoid'(skillsTitle as HTMLElement).style.breakAfter =
              'avoid'(skillsTitle as HTMLElement).style.marginBottom =
                '0.3cm'
          }
        }
      })

      // Настройки для PDF с улучшенными параметрами разбиения на страницы
      const opt = {
        margin: [20, 15, 20, 15], // [мм] верх, право, низ, лево - увеличили верхний и нижний отступы
        filename: `business_evolution_report_${personalInfo.lastName || 'user'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2, // Более высокое качество
          useCORS: true,
          letterRendering: true,
          scrollY: 0,
          logging: false, // Отключаем логи
          allowTaint: true, // Разрешаем работу с изображениями
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compress: true,
          precision: 16,
          putOnlyUsedFonts: true, // Оптимизация шрифтов
        },
        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy'],
          // Убираем автоматический разрыв перед секциями талантов, теперь управляем этим вручную
          avoid: [
            '.talent-title',
            '.talent-role',
            '.talent-description',
            '.business-roles',
            '.talent-info-group',
            '.levels-container',
            '.skills-container',
            'h3',
            'h4',
            '.level-item',
            '.skill-item',
          ],
        },
        enableLinks: true,
        footer: {
          height: '15mm',
          contents: {
            default:
              '<div style="text-align: center; font-size: 10px; color: #555; padding-top: 5px; border-top: 1px solid #eee;">' +
              '<span>Отчет создан с помощью </span>' +
              '<a href="https://my-business.evolution.life/" style="color: #10BDC8; text-decoration: none;">Business Evolution AI</a>' +
              '<span> • ' +
              dateStr +
              ' • </span>' +
              '<span>Страница {{page}} из {{pages}}</span></div>',
          },
        },
        header: {
          height: '15mm',
          contents: {
            default:
              '<div style="text-align: center; font-size: 10px; color: #555; padding-bottom: 5px; border-bottom: 1px solid #eee;">' +
              '<img src="/logotype.svg" style="height: 30px; margin-bottom: 5px;"><br>' +
              'Персональный отчет бизнес-талантов</div>',
            first:
              '<div style="text-align: center; font-size: 10px; color: #555; padding-bottom: 5px;">' +
              '<img src="/logotype.svg" style="height: 30px; margin-bottom: 5px;"></div>',
          },
        },
      }

      // Создаем PDF
      await html2pdf().set(opt).from(printElement).save()

      // Удаляем временный элемент
      document.body.removeChild(printElement)
    } catch (error) {
      console.error('Ошибка при создании PDF:', error)
      alert('Произошла ошибка при создании PDF. Пожалуйста, попробуйте еще раз.')
    } finally {
      setIsGeneratingPDF(false)
    }
  }

  // Helper function to get talent level and satisfaction
  const getTalentData = (talentId) => {
    const levelData = talentLevels.find((item) => Number(item.talentId) === Number(talentId))
    const satisfactionData = satisfactionLevels.find(
      (item) => Number(item.talentId) === Number(talentId),
    )
    const responseData = talentResponses.find((item) => Number(item.talentId) === Number(talentId))

    return {
      level: levelData ? levelData.level : 0,
      satisfaction: satisfactionData ? satisfactionData.level : 0,
      response: responseData ? responseData.response : '',
    }
  }

  const getTalentById = (talentId) => {
    return talents.find((talent) => Number(talent.Number) === Number(talentId))
  }

  // Преобразование строки уровней в массив
  const getLevels = (levelsString) => {
    if (!levelsString) return ['Нет данных']

    // Извлекаем все описания уровней
    const descriptions = [
      levelsString.includes('Нет (не развита):')
        ? levelsString
            .split('Нет (не развита):')[1]
            .split(/На низком уровне:|$/, 2)[0]
            .trim()
        : '',
      levelsString.includes('На низком уровне:')
        ? levelsString
            .split('На низком уровне:')[1]
            .split(/Средний уровень:|$/, 2)[0]
            .trim()
        : '',
      levelsString.includes('Средний уровень:')
        ? levelsString
            .split('Средний уровень:')[1]
            .split(/Выше среднего:|$/, 2)[0]
            .trim()
        : '',
      levelsString.includes('Выше среднего:')
        ? levelsString
            .split('Выше среднего:')[1]
            .split(/Высокий уровень:|$/, 2)[0]
            .trim()
        : '',
      levelsString.includes('Высокий уровень:')
        ? levelsString.split('Высокий уровень:')[1].trim()
        : '',
    ]

    return descriptions
  }

  // Форматирование скиллов
  const formatSkills = (skillsText) => {
    if (!skillsText) return []

    // Проверяем, содержит ли текст разделители
    if (skillsText.includes('—') || skillsText.includes(' - ')) {
      // Разбиваем текст на абзацы
      return skillsText
        .split(/\n/)
        .filter((line) => line.trim() !== '')
        .map((paragraph) => {
          // Ищем разделитель '—' или '-'
          const splitIndex = Math.max(paragraph.indexOf('—'), paragraph.indexOf(' - '))

          if (splitIndex !== -1) {
            const skillName = paragraph.substring(0, splitIndex).trim()
            const skillDescription = paragraph.substring(splitIndex + 1).trim()

            // Проверяем, есть ли пример в описании
            if (skillDescription.includes('Пример:')) {
              const [description, example] = skillDescription.split('Пример:')
              return {
                name: skillName,
                description: description.trim(),
                example: example.trim(),
              }
            }

            return {
              name: skillName,
              description: skillDescription,
              example: '',
            }
          }

          // Если разделитель не найден, возвращаем весь текст как имя навыка
          return {
            name: paragraph,
            description: '',
            example: '',
          }
        })
    } else {
      // Если нет явных разделителей, разбиваем текст на абзацы
      return skillsText
        .split(/\n/)
        .filter((line) => line.trim() !== '')
        .map((line) => ({
          name: line,
          description: '',
          example: '',
        }))
    }
  }

  // Переключение отображения ИПР для таланта
  const toggleTalentIPR = (talentId) => {
    setExpandedTalents((prev) => ({
      ...prev,
      [talentId]: !prev[talentId],
    }))
  }

  // Перейти в личный кабинет
  const goToDashboard = () => {
    navigate('/dashboard')
  }

  // Если данных о талантах нет или они не загружены
  if (!talents || talents.length === 0) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Данные о талантах не найдены</h2>
        <p>Пожалуйста, пройдите тест заново.</p>
        <button onClick={() => navigate('/')} className="btn">
          Вернуться на главную
        </button>
      </div>
    )
  }

  // Если не пройдена оценка талантов
  if (!talentLevels || talentLevels.length === 0) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Данные о талантах получены, но опрос еще не пройден</h2>
        <p>Пожалуйста, вернитесь назад, чтобы пройти опрос по оценке талантов.</p>
        <button onClick={() => navigate('/questionnaire')} className="btn">
          Перейти к опросу
        </button>
      </div>
    )
  }

  // Проверка на наличие талантов
  if (validTalentIndices.length === 0) {
    return (
      <div className="container">
        <div className="header">
          <div className="logo">
            Business <span>Evolution AI</span>
          </div>
        </div>
        <h2>Таланты не определены</h2>
        <p>Пожалуйста, пройдите тест заново.</p>
        <button onClick={() => navigate('/')} className="btn">
          Вернуться на главную
        </button>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="header">
        <div className="logo">
          Business <span>Evolution AI</span>
        </div>
        <div className="action-buttons">
          <button className="btn btn-dashboard" onClick={goToDashboard}>
            Личный кабинет
          </button>
          <button className="btn btn-profile" onClick={saveProfile} disabled={isSavingProfile}>
            {isSavingProfile ? 'Сохранение профиля...' : 'Сохранить в профиль'}
          </button>
          <button className="btn" onClick={generatePDF} disabled={isGeneratingPDF}>
            {isGeneratingPDF ? 'Создание PDF...' : 'Скачать отчет в PDF'}
          </button>
        </div>
      </div>

      {saveSuccess && (
        <div className="save-success">
          <p>Профиль успешно сохранен! Перенаправление...</p>
        </div>
      )}

      {saveError && (
        <div className="save-error">
          <p>Ошибка при сохранении профиля: {saveError}</p>
        </div>
      )}

      <div id="report-content">
        <div className="report-header">
          <h1>Персональный отчёт о бизнес-талантах</h1>
          <div className="personal-info-card">
            <div className="personal-info-item">
              <span className="label">Имя:</span>
              <span className="value">{personalInfo.firstName || 'Не указано'}</span>
            </div>
            <div className="personal-info-item">
              <span className="label">Фамилия:</span>
              <span className="value">{personalInfo.lastName || 'Не указано'}</span>
            </div>
            {personalInfo.position && (
              <div className="personal-info-item">
                <span className="label">Должность:</span>
                <span className="value">{personalInfo.position}</span>
              </div>
            )}
            {personalInfo.company && (
              <div className="personal-info-item">
                <span className="label">Компания:</span>
                <span className="value">{personalInfo.company}</span>
              </div>
            )}
            <div className="personal-info-item">
              <span className="label">Дата создания:</span>
              <span className="value">{new Date().toLocaleDateString()}</span>
            </div>
          </div>
        </div>

        <div className="report-intro">
          <p>
            Этот отчет представляет собой анализ бизнес-талантов, основанный на вашем врожденном
            потенциале. В отчете указаны ключевые таланты, их текущий уровень развития, а также
            рекомендации по их дальнейшему совершенствованию через индивидуальный план развития
            (ИПР).
          </p>
        </div>

        <h2>Врождённые таланты</h2>

        {validTalentIndices.map((talentId) => {
          const talent = getTalentById(talentId)
          if (!talent) {
            console.log(`Talent with id ${talentId} not found`)
            return null
          }

          const talentData = getTalentData(talentId)

          return (
            <TalentSection
              key={talentId}
              talent={talent}
              talentData={talentData}
              expandedTalents={expandedTalents}
              toggleTalentIPR={toggleTalentIPR}
              formatSkills={formatSkills}
              getLevels={getLevels}
            />
          )
        })}

        <div className="report-footer">
          <p>
            Этот отчет был создан с помощью сервиса{' '}
            <a href="https://my-business.evolution.life/" target="_blank" rel="noopener noreferrer">
              Business Evolution AI
            </a>
            . Система использует технологию анализа природных склонностей с точностью более 90% и
            собственную базу бизнес-архетипов личности для выявления потенциала в наилучших ролях в
            бизнесе.
          </p>
          <div className="report-date">Дата создания: {new Date().toLocaleDateString()}</div>
        </div>
      </div>
    </div>
  )
}

export default ResultsPage
